export const MOCK_PRODUCT_JOURNAL_ENTRIES = {
  "prod-101": [
    // Scenario 1: Receipt + Defect Adjustment related entries
    {
      id: 1,
      date: "2026-07-26T10:30:00Z",
      movementType: "Receipt",
      warehouse: "Warehouse Bangalore",
      batchNumber: "B-MCB-101",
      quantity: 150,
      runningBalance: 150,
      reference: "PO-10024",
      recordedBy: "Ramesh Kumar",
    },
    {
      id: 2,
      date: "2026-07-26T11:00:00Z",
      movementType: "Defect Adjustment",
      warehouse: "Warehouse Bangalore",
      batchNumber: "B-MCB-101",
      quantity: -10,
      runningBalance: 140,
      reference: "PO-10024", // Related to Receipt PO
      recordedBy: "Ramesh Kumar",
    },

    // Scenario 2: Transfer Out + Transfer In sharing same reference
    {
      id: 3,
      date: "2026-07-27T14:00:00Z",
      movementType: "Transfer Out",
      warehouse: "Warehouse Bangalore",
      batchNumber: "B-MCB-101",
      quantity: -60,
      runningBalance: 80,
      reference: "TRF-2001",
      recordedBy: "Arul Selvan",
    },
    {
      id: 4,
      date: "2026-07-27T14:30:00Z",
      movementType: "Transfer In",
      warehouse: "Peelamedu Depot",
      batchNumber: "B-MCB-201",
      quantity: 60,
      runningBalance: 60,
      reference: "TRF-2001", // Shares same transfer reference code
      recordedBy: "Arul Selvan",
    },

    // Scenario 3: Reservation with Allocation reference code
    {
      id: 5,
      date: "2026-07-28T09:15:00Z",
      movementType: "Reservation",
      warehouse: "Warehouse Bangalore",
      batchNumber: "B-MCB-102",
      quantity: -60,
      runningBalance: 20,
      reference: "ALC-0027", // Reservation allocation reference
      recordedBy: "Ramesh Kumar",
    },

    // Scenario 4: Outward reducing total stock
    {
      id: 6,
      date: "2026-07-29T10:00:00Z",
      movementType: "Outward",
      warehouse: "Warehouse Bangalore",
      batchNumber: "B-MCB-102",
      quantity: -20,
      runningBalance: 0,
      reference: "INV-2345",
      recordedBy: "Ramesh Kumar",
    },

    // Scenario 5: Revocation releasing reserved stock
    {
      id: 7,
      date: "2026-07-30T11:45:00Z",
      movementType: "Revocation",
      warehouse: "Warehouse Bangalore",
      batchNumber: "B-MCB-102",
      quantity: 60,
      runningBalance: 60,
      reference: "ALC-0027",
      recordedBy: "Ramesh Kumar",
    },

    // Scenario 6: Return referencing Customer Invoice ID
    {
      id: 8,
      date: "2026-07-31T15:20:00Z",
      movementType: "Return",
      warehouse: "Warehouse Bangalore",
      batchNumber: "B-MCB-101",
      quantity: 10,
      runningBalance: 70,
      reference: "INV-SME-0523", // Related Customer Invoice Reference
      recordedBy: "Ramesh Kumar",
    },
  ],
  "prod-102": [
    {
      id: 1,
      date: "2026-07-28T13:45:00Z",
      movementType: "Receipt",
      warehouse: "Warehouse Bangalore",
      batchNumber: "B-PMP-101",
      quantity: 45,
      runningBalance: 45,
      reference: "PO-10025",
      recordedBy: "Srinivasan M",
    },
    {
      id: 2,
      date: "2026-07-29T15:30:00Z",
      movementType: "Reservation",
      warehouse: "Warehouse Bangalore",
      batchNumber: "B-PMP-101",
      quantity: -40,
      runningBalance: 5,
      reference: "ALC-0028",
      recordedBy: "Srinivasan M",
    },
  ],
};
